import React from "react"

const Container = (props) => {
  return (
    <div
      style={{
        background: "#F5F8F7",
        paddingBottom: "0.5em",
        maxWidth: "640px",
        margin: "0 auto",
        paddingTop: "10px",
      }}
    >
      {props.children}
    </div>
  )
}

export default Container
